module.exports = __webpack_public_path__ + "img/0026.6c70328c.jpg";